export const MultiStepFormContainer = ({ children }) => {
  return <>{children}</>;
};
